// src/pages/Login.jsx
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { signInWithGoogle } from "../auth";

export default function Login() {
  const [err, setErr] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/";

  const onGoogle = async () => {
    setErr("");
    try {
      await signInWithGoogle(); // Google popup [web:21]
      navigate(from, { replace: true }); // go back or home [web:101]
    } catch (e) {
      setErr(e.message);
    }
  };

  return (
    <div style={{ padding: 16 }}>
      <h2>Login</h2>
      <button onClick={onGoogle}>Continue with Google</button>
      {err && <p style={{ color: "red" }}>{err}</p>}
    </div>
  );
}
